/*
 * File: /src/router/routes/admin.js
 * Created Date: Tuesday August 27th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 27th August 2019 10:21:36 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const CompanyList = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/CompanyList.vue');

const CompanyEdit = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/CompanyEdit.vue');

const CompanyView = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/CompanyView.vue');

const CompanyAgency = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/CompanyAgency.vue');

const UserAdd = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/UserAdd.vue');

const UserEdit = () =>
  import(/* webpackChunkName: "AccountAdmin" */ 'src/components/Dashboard/Views/Admin/UserEdit.vue');

export const adminRoutes = [
  {
    path: 'accounts/',
    name: 'List all accounts',
    component: CompanyList
  },
  {
    path: 'accounts/:id(\\d+)/',
    name: 'Viewing Company Account',
    component: CompanyView
  },
  {
    path: 'accounts/:id(\\d+)/edit/',
    name: 'Edit Company Account',
    component: CompanyEdit
  },
  {
    path: 'accounts/:id(\\d+)/agency/',
    name: 'Company Agency Settings',
    component: CompanyAgency
  },
  {
    path: 'accounts/:id(\\d+)/user/add/',
    name: 'Adding user',
    component: UserAdd
  },
  {
    path: 'accounts/:id(\\d+)/user/edit/:userId(\\d+)/',
    name: 'Editing user',
    component: UserEdit
  }
];
